import HTTPAPIConnectionPanel, { EMPTY_HTTP_API_DRAFT } from "./HTTPAPIConnectionPanel";
import { Braces, Cable } from "lucide-react";

const cloneHTTPDraft = () => ({ ...EMPTY_HTTP_API_DRAFT });

const MCP_PROTOCOL = {
  value: "mcp",
  label: "MCP Connection",
  Icon: Cable,
  Panel: null,
  createDraft: () => null,
  discovery: {
    validationFields: ["mcp_connection"],
    canRun: ({ provider, connection }) => Boolean(provider && connection.mcp_connection),
    buildRequest: ({ provider, connection }) => ({
      connection_type: "mcp",
      provider,
      ...connection,
    }),
  },
  isReady: () => true,
  serializeSource: () => null,
  parseConfiguration: () => null,
};

const HTTP_API_PROTOCOL = {
  value: "http_api",
  label: "HTTP API",
  Icon: Braces,
  Panel: HTTPAPIConnectionPanel,
  createDraft: cloneHTTPDraft,
  discovery: {
    validationFields: [],
    canRun: ({ provider, draft }) => Boolean(provider && draft?.convertedDraft),
    buildRequest: ({ provider, draft }) => ({
      connection_type: "http_api",
      provider,
      configuration: {
        schema_version: 1,
        connection_type: "http_api",
        source: {
          base_uri: draft.baseURI,
          schema: draft.schema,
          format: draft.format,
        },
        compiled: draft.convertedDraft,
      },
    }),
  },
  isReady: (draft) => Boolean(draft?.convertedDraft),
  readinessError: (action) => `Convert the current HTTP API schema before ${action} the agent`,
  serializeSource: (draft) => ({
    base_uri: draft.baseURI,
    schema: draft.schema,
    format: draft.format,
  }),
  parseConfiguration: (configuration) => {
    if (
      configuration?.schema_version !== 1
      || configuration?.connection_type !== "http_api"
      || typeof configuration.source?.base_uri !== "string"
      || typeof configuration.source?.schema !== "string"
      || !["json", "yaml"].includes(configuration.source?.format)
      || configuration.compiled?.schema_version !== 1
      || configuration.compiled?.draft !== true
    ) {
      throw new Error("Invalid saved HTTP API connection configuration");
    }
    return {
      baseURI: configuration.source.base_uri,
      schema: configuration.source.schema,
      format: configuration.source.format,
      convertedDraft: configuration.compiled,
    };
  },
};

export const CONNECTION_PROTOCOLS = [MCP_PROTOCOL, HTTP_API_PROTOCOL];

export const CONNECTION_PROTOCOL_OPTIONS = CONNECTION_PROTOCOLS.map(
  ({ value, label, Icon }) => ({ value, label, Icon })
);

export const createConnectionDrafts = () => Object.fromEntries(
  CONNECTION_PROTOCOLS.filter(({ Panel }) => Panel).map((protocol) => [
    protocol.value,
    protocol.createDraft(),
  ])
);

export const getConnectionProtocol = (connectionType) => {
  const protocol = CONNECTION_PROTOCOLS.find(({ value }) => value === connectionType);
  if (!protocol) throw new Error(`Unsupported connection type: ${connectionType}`);
  return protocol;
};